// Asegúrate de que el DOM esté completamente cargado
document.addEventListener('DOMContentLoaded', function() {
    let checker = document.getElementById('flexi-checker');

    // Verificar inmediatamente si checker existe
    if (!checker) {
        setTimeout(function() {
            // Verificar de nuevo si checker todavía no existe
            console.log("Checking for flexi-checker after 10 seconds...");
            checker = document.getElementById('flexi-checker');
            if (!checker) {
                displayBanner();
                console.log("flexi-checker not found. Displaying banner...");
            }
        }, 10000); // 10 segundos
    }

    // Función para mostrar el banner
    function displayBanner() {
        var flexiBanner = document.getElementById('flexi-embed-banner');
        if (flexiBanner) {
            flexiBanner.style.display = 'block';
        }
    }

    // Inicialización del acordeón
    const initAccordion = () => {
        const accordionItems = document.querySelectorAll('.accordion-item');
        accordionItems.forEach(item => {
            const header = item.querySelector('.accordion-header');
            if (header) {
                header.addEventListener('click', onClickAccordionHeader, false);
            }
        });
    };

    // Manejar clic en el encabezado del acordeón
    const onClickAccordionHeader = (e) => {
        const parentAccordion = e.currentTarget.closest('.accordion');
        const accordionItems = parentAccordion.querySelectorAll('.accordion-item');

        if (e.currentTarget.parentNode.classList.contains('active')) {
            e.currentTarget.parentNode.classList.remove("active");
        } else {
            accordionItems.forEach(item => item.classList.remove('active'));
            e.currentTarget.parentNode.classList.add("active");
        }
    };

    // Inicializar acordeón
    initAccordion();

    // Comprobar si la URL contiene '#scroll-point'
    if (window.location.hash === '#scroll-point') {
        // Desplazar hacia la parte superior de la página
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }

    // Agregar listener a todos los enlaces con href '#scroll-point'
    const viewProductLinks = document.querySelectorAll("a[href='#scroll-point']");
    viewProductLinks.forEach(function(viewProductLink) {
        viewProductLink.addEventListener("click", function(e) {
            e.preventDefault();
            window.scrollTo({ top: 0, behavior: 'smooth' });
        });
    });
});
